var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('span',{key:_vm.GetKey(),staticClass:"basic-span"},[_vm._v(_vm._s(_vm.timeText))])])}
var staticRenderFns = []

export { render, staticRenderFns }